<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<p class="fm_head">Contents</p>
<p class="toc" id="r_ch1"><a href="#/text/chapter_01#ch1">Chapter One</a></p>
<p class="toc" id="r_ch2"><span href="#/text/chapter_02#ch2" title="Link target outside of Sample">Chapter Two</span></p>
<p class="toc" id="r_ch3"><span href="#/text/chapter_03#ch3" title="Link target outside of Sample">Chapter Three</span></p>
<p class="toc" id="r_ch4"><span href="#/text/chapter_04#ch4" title="Link target outside of Sample">Chapter Four</span></p>
<p class="toc" id="r_ch5"><span href="#/text/chapter_05#ch5" title="Link target outside of Sample">Chapter Five</span></p>
<p class="toc" id="r_ch6"><span href="#/text/chapter_06#ch6" title="Link target outside of Sample">Chapter Six</span></p>
<p class="toc" id="r_ch7"><span href="#/text/chapter_07#ch7" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="toc" id="r_ch8"><span href="#/text/chapter_08#ch8" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="toc" id="r_ch9"><span href="#/text/chapter_09#ch9" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="toc1" id="r_bm2"><span href="#/text/backmatter_02#bm2" title="Link target outside of Sample">Last Will and Testament</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?1c287ddc